import { API, API_GET_ID } from "../../Config";

export const GetSingleController = (id) => {
  return API_GET_ID(API.SingleSubAdmin,id);
};
